import React from 'react';
import loadable from '@loadable/component';
import { Props } from './view';

const AlertsLoadable = loadable(() =>
  import(/* webpackChunkName: "sidebar-views" */ './view')
);

const Alerts = (props: Props) => <AlertsLoadable {...props} />;

export default Alerts;
